import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import LoginPage from './pages/LoginPage';


class Auth extends PureComponent {
  render() {
    return (
      <div className="login_bgr">
        <Switch>
          <Route
            exact
            path="/login"
            component={LoginPage}
          />
        </Switch>
      </div>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/Auth/AuthModule.js